import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['root', 'indicator', 'text'];
var baseStyle = {
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  indicator: {
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '50%',
    display: 'inline-block',
    mr: 2,
    flexShrink: 0
  },
  text: {
    color: 'grey.980',
    fontWeight: 'bold'
  }
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});